export const GROUP_ROLE_CATE_LIST_REQUEST = 'GROUP_ROLE_CATE_LIST_REQUEST';
export const GROUP_ROLE_UPDATE_REQUEST = 'GROUP_ROLE_UPDATE_REQUEST';

export const SYSTEM_API_ROLE_LIST_REQUEST = 'SYSTEM_API_ROLE_LIST_REQUEST';

export const SYSTEM_API_ROEL_DELETE_REQUEST = 'SYSTEM_API_ROEL_DELETE_REQUEST';

export const SYSTEM_API_ROEL_UPDATE_REQUEST = 'SYSTEM_API_ROEL_UPDATE_REQUEST';
